<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import GoBack from "../components/GoBack/GoBack.vue";
import { useRoute } from "vue-router";
const store = useStore();
const route = useRoute();
let server = ref(process.env.VUE_APP_BASE_API);
let username = ref("");
let truename = ref("");
let appkey = ref("");
let certificate_content = ref(""); // 证书类别
onMounted(() => {
  if (store.getters.isLogin) {
    let data = store.state.userInfo;
    username.value = data.username;
    truename.value = route.query.truename
      ? route.query.truename
      : data.truename;
    appkey.value = store.state.appkey;
    certificate_content.value =
      store.state.partnerConfig?.basic?.certificate_content;
  }
});
</script>
<template>
  <GoBack :type="1" />
  <div class="main">
    <img
      :src="`${server}/api/app/lining.php?action=zhengshu&appkey=${appkey}${
        certificate_content == 1 ? `&username=${username}` : ''
      }&truename=${truename}`"
      alt=""
    />
  </div>
</template>

<style lang="scss" scoped>
.main {
  img {
    width: 100%;
    height: auto;
  }
}
</style>
